import clsx from "clsx";
import { DropdownRoot } from "./Dropdown.styles";
import { DropdownOnClickOption, DropdownProps, DropdownToOption } from "./Dropdown.types";
import DropdownValue from "./DropdownValue/DropdownValue";
import DropdownItem from "./DropdownItem/DropdownItem";

export default function Dropdown<T, Multiple extends boolean = false>({
    prefix,
    suffix,
    children,
    label,
    className,
    rounded = true,
    options,
    ...rest
}: DropdownProps<T, Multiple>): JSX.Element {
    // skipcq: JS-0437 - Ignorar advertencia sobre falta de retorno en arrow function
    return (
        <DropdownRoot
            renderValue={() => <DropdownValue label={label} prefix={prefix} suffix={suffix} />}
            className={clsx("dropdown", className)}
            size="md"
            rounded={rounded}
            onChange={() => undefined}
            {...rest}
        >
            {options
                ? options.map((option, i) => (
                    <DropdownItem
                        // skipcq: JS-0437 - no hay id se usa index
                        key={`${option.label}-${i}`}
                        label={option.label}
                        to={(option as DropdownToOption).to}
                        onClick={(option as DropdownOnClickOption).onClick}
                    />
                ))
                : children}
        </DropdownRoot>
    );
}
